import platform from "../../../util/platform";
const upsert = (feature) => {
    return (params) => {
        const path = `/app/features/create`;
        return platform.post(params, platform.getEdgeBaseUrl(), path, feature);
    };
};
const getAllForVendor = () => {
    return (params) => {
        const path = `/app/features/all`;
        return platform.get(params, platform.getEdgeBaseUrl(), path);
    };
};
const get = (featureType) => {
    return (params) => {
        const path = `/app/features/type/${featureType}`;
        return platform.get(params, platform.getEdgeBaseUrl(), path);
    };
};
const appConfigFeatures = {
    upsert,
    getAllForVendor,
    get,
};
export default appConfigFeatures;
